import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import LoadingSpinner from "views/Components/loadingSpinner";
import { displayMoney, groupOrdersByMonth } from "../CallLeadDetails.utils";

const RecentOrders = ({ resource, formatDate, leadId, leadName, type, compact = false }) => {
  const groups = groupOrdersByMonth(resource.data);
  const latestKey = groups.length ? groups[0].key : "";
  const [expandedMonths, setExpandedMonths] = useState(() => new Set());
  const isLab = type === "lab";

  const getStatus = (order) =>
    String(order.order_status_label || order.status_label || order.order_status || "—");
  const getStatusKey = (status) =>
    status.toLowerCase().trim().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "") || "unknown";

  useEffect(() => {
    setExpandedMonths(latestKey ? new Set([latestKey]) : new Set());
  }, [latestKey, leadId]);

  const toggleMonth = (key) => {
    setExpandedMonths((current) => {
      const next = new Set(current);
      if (next.has(key)) next.delete(key);
      else next.add(key);
      return next;
    });
  };

  const historyPath = isLab
    ? "/admin/lab_order_list?name=" + encodeURIComponent(leadName)
    : "/admin/order_list?name=" + encodeURIComponent(leadName);

  return (
    <div className="cw-recent-orders">
      {resource.loading ? (
        <div className="cw-inline-loading"><LoadingSpinner /></div>
      ) : resource.error ? (
        <div className="cw-tab-error" role="alert">{resource.error}</div>
      ) : !groups.length ? (
        <p className="cw-muted cw-empty-state">No recent orders found.</p>
      ) : (
        <>
          <div className="cw-recent-orders-heading">
            <div>
              <strong>Recent {isLab ? "lab" : "medicine"} orders</strong>
              {resource.period ? (
                <small>{resource.period.from + " to " + resource.period.to}</small>
              ) : null}
            </div>
            <Link className="cw-history-link" to={historyPath}>
              View all {isLab ? "lab" : "medicine"} orders
              <i className="fa fa-external-link" aria-hidden="true" />
            </Link>
          </div>
          <div className="cw-month-groups">
            {groups.map((group) => {
              const expanded = expandedMonths.has(group.key);
              const panelId = "cw-" + type + "-month-" + group.key;
              return (
                <section className="cw-month-group" key={group.key}>
                  <button
                    type="button"
                    className="cw-month-toggle"
                    aria-expanded={expanded}
                    aria-controls={panelId}
                    onClick={() => toggleMonth(group.key)}
                  >
                    <span>{group.label}</span>
                    <span className="cw-month-count">
                      {group.orders.length}{" "}
                      {group.orders.length === 1 ? "order" : "orders"}
                    </span>
                    <i
                      className={"fa fa-chevron-" + (expanded ? "up" : "down")}
                      aria-hidden="true"
                    />
                  </button>
                  {expanded ? (
                    <ul className="cw-month-orders" id={panelId}>
                      {group.orders.map((order) => (
                        <li key={order.id}>
                          <Link
                            className={[
                              "cw-order-row",
                              isLab ? "cw-order-row-lab" : "",
                              compact ? "cw-drawer-order-row" : "",
                            ].filter(Boolean).join(" ")}
                            to={(isLab ? "/admin/laborder/" : "/admin/order-new/") + order.id}
                          >
                            <strong>#{order.id}</strong>
                            <span>{formatDate(order.created_at, true)}</span>
                            <span
                              className={"cw-order-status cw-order-status-" + getStatusKey(getStatus(order))}
                              title={getStatus(order)}
                            >
                              {getStatus(order)}
                            </span>
                            {isLab && !compact ? (
                              <span>{order.partner_name || order.lab_partner_name || "—"}</span>
                            ) : null}
                            <span>{displayMoney(order.total_cost)}</span>
                            <i className="fa fa-chevron-right" aria-hidden="true" />
                          </Link>
                        </li>
                      ))}
                    </ul>
                  ) : null}
                </section>
              );
            })}
          </div>
        </>
      )}
    </div>
  );
};

export default RecentOrders;
